export enum NewsRecommendMethod {
  /**
   * 无
   */
  NONE = 0,
  /**
   * 置顶
   */
  TOP = 1,
  /**
   * 推荐
   */
  RECOMMEND = 2
}

export const NewsRecommendMethodTextMap = {
  [NewsRecommendMethod.NONE]: '无',
  [NewsRecommendMethod.TOP]: '置顶',
  [NewsRecommendMethod.RECOMMEND]: '推荐'
}
